
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import React from 'react';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import CallToAction from '@/components/CallToAction';
import Features2 from '@/components/Features2';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
import Testimonials from '@/components/Testimonials';
const FreeTools = () => {
    const { t } = useLocale('tools');
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      <Seo templateTitle={t('Free AI Tools')} description={t('Discover the magic of AI with Easy-Peasy.AI’s suite of free tools.')} image={`https://easy-peasy.ai/api/og-template?title=${t('Free AI Tools')}
          &description=${t('Discover the magic of AI with Easy-Peasy.AI’s suite of free tools.')}`}/>
      <div className='relative overflow-hidden bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <div className='relative z-10 bg-white pb-8 dark:bg-slate-900  lg:w-full'>
            <div className='relative  bg-white dark:bg-slate-900'>
              <div className='mx-auto'>
                <LandingPageNavigation />

                <main className='mx-auto mt-16 max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32'>
                  <div className=''>
                    <div className='relative z-30 text-center md:mx-auto'>
                      <h1>
                        <span className='rounded bg-primary-50 px-2.5 py-1 text-xl font-semibold text-primary-600 dark:bg-slate-800'>
                          {t('Free AI Tools')}
                        </span>
                        <span className='mt-1 block text-4xl font-bold tracking-tight sm:text-5xl '>
                          <span className='block text-gray-900 dark:text-slate-200'>
                            {t('Get high-quality copy')}
                          </span>
                          <span className='block text-primary-600'>
                            {t('written fast with AI')}
                          </span>
                        </span>
                      </h1>
                      <p className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl'>
                        {t('Discover the magic of AI with Easy-Peasy.AI’s suite of free tools.')}
                      </p>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Features2 showAll={true} isFree={true}/>

      <Testimonials />
      <CallToAction />
      <Footer />
    </main>);
};
export default FreeTools;

    async function __Next_Translate__getStaticProps__1a13a29a248__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/free-tools/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13a29a248__ as getStaticProps }
  